export default __webpack_public_path__ + "static/media/poster-3-video-2.a2b075ce.png";